import type { LandingBlock } from '@entities/LandingPage'

import { captureMessage } from '@shared/lib/sentry'

/*
  A block type the registry does not know is skipped rather than rendered — the
  page must not break. But it is a signal worth seeing: the backend is serving a
  block this release cannot render, so it is reported once per type.
*/
const reported = new Set<string>()

export function reportUnknownLandingBlock (block: LandingBlock): void {
  const type = block?.type ?? 'unknown'

  if (reported.has(type)) {
    return
  }

  reported.add(type)

  const detail = `type=${type} subtype=${block?.subtype ?? '-'} id=${block?.id ?? '-'}`

  if (import.meta.env.DEV) {
    console.warn(`[landing] unsupported block skipped: ${detail}`)
  }

  captureMessage(`[landing] unsupported block skipped: ${detail}`, 'warning')
}
